import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

import { computed, defineComponent } from 'vue';
import { UiAvatar } from '@huntflow/ui';
import type { ApplicantLog } from '@/shared/legacy/types/applicant-log';
import type { Applicant } from '@/shared/legacy/types/applicant';
import { PhotoHelper } from '@/modules/applicant-photo-editor/helper';
import { EntityType } from '@/shared/legacy/api/photo';
import { LogItemType } from '@/shared/legacy/types/log-item-type';

type Props = {
  logItems: Array<ApplicantLog>;
  applicant: Applicant;
  getKey: () => any;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'log-items-timeline',
  props: {
    logItems: {},
    applicant: {},
    getKey: { type: Function }
  },
  setup(__props: any) {



defineComponent({
  name: 'LogItemsTimeline'
});

const grouppedLogItems = computed(() => {
  const groups: ApplicantLog[][] = [];
  let latestAccount = null;
  __props.logItems.forEach((logItem) => {
    if (latestAccount !== logItem.account) {
      latestAccount = logItem.account;
      groups.push([]);
    }
    groups[groups.length - 1].push(logItem);
  });
  return groups;
});

function getLogPhoto(logItem) {
  const isResponse = logItem.type === LogItemType.RESPONSE;
  let data;
  if (isResponse) {
    data = {
      entity: __props.applicant,
      type:
        logItem.status === 'response' // у лога статус может быть любой статус и для откликов надо это учитывать
          ? EntityType.APPLICANT_RESPONSE // это для лога в разделе с откликами
          : EntityType.APPLICANT // а это когда мы кандидата взяли из откликов в работу
    };
  } else {
    data = {
      entity: logItem?.account_info ?? {},
      type: EntityType.USER
    };
  }
  return PhotoHelper.getPhotoUrl(data);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.timeline)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grouppedLogItems.value, (logGroup) => {
      return (_openBlock(), _createElementBlock("div", {
        key: logGroup[0].account,
        class: _normalizeClass({
        [_ctx.$style.timelineGroup]: true,
        [_ctx.$style.singleton]: logGroup.length === 1
      })
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.photoShaft)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.photo)
          }, [
            _createVNode(_unref(UiAvatar), {
              src: getLogPhoto(logGroup[0]),
              size: "m"
            }, null, 8, ["src"])
          ], 2)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logGroup, (logItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: __props.getKey(logItem),
            class: _normalizeClass(_ctx.$style.timelineGroupItem)
          }, [
            _renderSlot(_ctx.$slots, "item", { logItem: logItem })
          ], 2))
        }), 128))
      ], 2))
    }), 128))
  ], 2))
}
}

})